import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import cn from 'classnames';

import { ArrowLeftSVG } from '../../../../components/Iconography';

import styles from './styles.module.css';

class ParentMobile extends PureComponent {
  render() {
    const { className, parentLink, onClick } = this.props;

    if (!parentLink) return null;

    const { text, link } = parentLink;

    return (
      <div className={cn(className, styles.parentLink)}>
        <Link
          to={link}
          onClick={() =>
            onClick({
              anchorText: text,
              permalink: link,
              // Index set to one to mimic the value of the first, clickable desktop breadcrumb.
              index: 1,
            })
          }
        >
          <ArrowLeftSVG className={styles.arrow} />
          <span>{text}</span>
        </Link>
      </div>
    );
  }
}

export default ParentMobile;
